/* Caller/callee action creators + Agora glue for CallContext.
 *
 * Kept as plain functions (not hooks) so the parent context can bind
 * them once via useCallback and expose stable references to consumers. */
import { toast } from "sonner";
import {
  startCall as apiStartCall,
  answerCall as apiAnswerCall,
  rejectCall as apiRejectCall,
  cancelCall as apiCancelCall,
  endCall as apiEndCall,
} from "../../lib/callsApi";
import { unlockAudio } from "../../lib/ringer";
import { PHASE } from "./_phase";

export async function doStartCall({
  conversationId, calleeId, calleeProfile, phase, voice,
  setError, setPhase, setPeer, setActiveCall, reset,
}) {
  if (phase !== PHASE.IDLE) return;
  unlockAudio();
  setError(null);
  setPhase(PHASE.DIALING);
  setPeer(calleeProfile || { id: calleeId });
  try {
    const data = await apiStartCall({
      conversation_id: conversationId,
      callee_id: calleeId,
    });
    setActiveCall({ ...data.call, ...data.agora });
    setPeer(data.callee || calleeProfile || { id: calleeId });
    await voice.join({
      appId: data.agora.app_id,
      channel: data.agora.channel,
      token: data.agora.token,
      uid: data.agora.uid,
    });
  } catch (e) {
    const msg = e?.response?.data?.detail || e?.message || "تعذّر بدء المكالمة";
    toast.error(msg);
    setError(msg);
    await reset();
  }
}

export async function doAccept({
  call, phase, voice, setPhase, setCallStartedAt, setError, reset,
}) {
  if (!call || phase !== PHASE.INCOMING) return;
  unlockAudio();
  try {
    const data = await apiAnswerCall(call.id);
    await voice.join({
      appId: data.agora.app_id,
      channel: data.agora.channel,
      token: data.agora.token,
      uid: data.agora.uid,
    });
    setPhase(PHASE.IN_CALL);
    setCallStartedAt(Date.now());
  } catch (e) {
    const msg = e?.response?.data?.detail || e?.message || "تعذّر الردّ على المكالمة";
    toast.error(msg);
    setError(msg);
    await reset();
  }
}

export async function doDecline(call, reset) {
  if (!call) return reset();
  try { await apiRejectCall(call.id); } catch { /* noop */ }
  await reset();
}

export async function doHangup(call, phase, reset) {
  if (!call) return reset();
  try {
    if (phase === PHASE.DIALING) await apiCancelCall(call.id);
    else await apiEndCall(call.id);
  } catch { /* noop */ }
  await reset();
}
